<template>
  <ticket-manage-page></ticket-manage-page>
</template>

<script>
import TicketManagePage from './TicketManagePage'
export default {
  name: 'TicketManage',
  components: {
    TicketManagePage
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ticket_manage/TicketManage.vue